import { trackKlaviyo } from '../../utils/dom';
import { atob, applyVAT, baseName, cacheName, urlify } from '../../utils/string';
import { prefix } from '../../utils/locale';

const cartAnalytics = (selected, cache, productVariantLookup, setup, currentCategory, selection, fromList = '', remove = false, quantity = 1) => {
	if (typeof window.dataLayer === 'undefined') window.dataLayer = [];
	if (!Array.isArray(selected)) selected = [{ merchandiseId: selected }];
	const itemIds = selected.map((s) => (s.merchandiseId || s).replace('gid://shopify/ProductVariant/', ''));
	const value = itemIds.reduce((acc, itemId) => {
		const cachedProduct = cache[productVariantLookup[itemId]];
		if (!cachedProduct) return acc;
		return acc + parseInt(applyVAT(setup, cachedProduct.price), 10);
	}, 0);

	if (remove) {
		window.dataLayer.push({ ecommerce: null });
		window.dataLayer.push({
			event: 'remove_from_cart',
			ecommerce: {
				currency: setup.currency,
				value,
				items: itemIds.map((itemId) => {
					const cachedProduct = cache[productVariantLookup[itemId]];
					if (!cachedProduct) return false;
					const itemCategory = (cachedProduct.canonicalUri || '').split('/').slice(0, -1).reduce((acc, category, j) => ({ ...acc, [`item_category${j > 0 ? j + 1 : ''}`]: category }), {});
					const itemList = typeof fromList === 'string' ? fromList : (fromList[cachedProduct.variantId] || '');

					return {
						item_name: cachedProduct.name,
						item_id: cachedProduct.variantId,
						price: applyVAT(setup, cachedProduct.price),
						item_brand: cachedProduct.brand,
						...itemCategory,
						item_list_id: urlify(itemList),
						item_list_name: itemList,
						item_variant: cachedProduct.variant,
						quantity: `${quantity}`,
					};
				}).filter((a) => !!a),
			},
		});
		return;
	}

	window.dataLayer.push({ ecommerce: null });
	window.dataLayer.push({
		event: 'AddToCart',
		values: {
			content_type: 'product',
			content_ids: itemIds,
			currency: setup.currency,
			value,
		},
	});

	window.dataLayer.push({ ecommerce: null });
	window.dataLayer.push({
		event: 'AddToCartGA',
		ecommerce: {
			currencyCode: setup.currency,
			add: {
				products: itemIds.map((itemId) => {
					const cachedProduct = cache[productVariantLookup[itemId]];
					if (!cachedProduct) return false;

					return {
						name: cachedProduct.name,
						id: cachedProduct.variantId,
						price: applyVAT(setup, cachedProduct.price),
						brand: cachedProduct.brand,
						category: currentCategory,
						variant: cachedProduct.variant,
						quantity: `${quantity}`,
					};
				}).filter((a) => !!a),
			},
		},
	});

	window.dataLayer.push({ ecommerce: null });
	window.dataLayer.push({
		event: 'add_to_cart',
		ecommerce: {
			currency: setup.currency,
			value,
			items: itemIds.map((itemId) => {
				const cachedProduct = cache[productVariantLookup[itemId]];
				if (!cachedProduct) return false;
				const itemCategory = (cachedProduct.canonicalUri || '').split('/').slice(0, -1).reduce((acc, category, j) => ({ ...acc, [`item_category${j > 0 ? j + 1 : ''}`]: category }), {});
				const itemList = typeof fromList === 'string' ? fromList : (fromList[cachedProduct.variantId] || '');

				return {
					item_name: cachedProduct.name,
					item_id: cachedProduct.variantId,
					price: applyVAT(setup, cachedProduct.price),
					item_brand: cachedProduct.brand,
					...itemCategory,
					item_list_id: urlify(itemList),
					item_list_name: itemList,
					item_variant: cachedProduct.variant,
					quantity: `${quantity}`,
				};
			}).filter((a) => !!a),
		},
	});

	itemIds.forEach((itemId) => {
		const cachedProduct = cache[productVariantLookup[itemId]];
		if (!cachedProduct) return;

		const size = cachedProduct.sizes.filter((s) => s.id.indexOf(itemIds[0]) !== -1).shift();
		const currency = selection.cost.totalAmount.currencyCode || setup.currency;

		const payload = {
			$value: applyVAT(setup, selection.cost.totalAmount.amount),
			Currency: setup.currency,
			AddedItemProductName: cachedProduct.name,
			AddedItemProductID: cachedProduct.id,
			AddedItemSKU: size.sku,
			AddedItemCategories: cachedProduct.canonicalUri.split('/').slice(0, -1),
			AddedItemImageURL: cachedProduct.media?.[0]?.src || '',
			AddedItemURL: `${window.location.origin}${prefix(setup, cachedProduct.canonicalUri)}`,
			AddedItemPrice: applyVAT(setup, cachedProduct.price[currency]),
			AddedItemQuantity: quantity,
			ItemNames: selection.lines.edges.map((i) => i.node?.merchandise?.product?.title),
			CheckoutURL: selection.checkoutUrl,
			Items: selection.lines.edges.map((item) => {
				const i = item.node;
				const productId = baseName(i?.merchandise?.product?.id);
				const cachedItemId = cacheName(productId, i.merchandise.selectedOptions);
				const cachedItem = cache[cachedItemId] || {};

				return {
					ProductID: productId,
					SKU: i?.merchandise?.sku,
					ProductName: i?.merchandise?.product?.title,
					Quantity: i.quantity,
					ItemPrice: applyVAT(setup, i?.merchandise?.priceV2.amount),
					RowTotal: applyVAT(setup, i?.merchandise?.priceV2.amount * parseInt(i.quantity, 10)),
					ProductURL: `${window.location.origin}${prefix(setup, cachedItem.canonicalUri)}`,
					ImageURL: cachedItem.media?.[0]?.src || '',
					ProductCategories: (cachedItem.canonicalUri || '').split('/').slice(0, -1),
					Currency: setup.currency,
				};
			}),
		};

		trackKlaviyo((kl) => {
			kl.track('Added to Cart', payload);
		});
	});
};

export default cartAnalytics;
